import { logError } from '../shared/utils/logging';
import { REGISTERED_APPS } from '../shared/types';
import { isCartPage } from '../utils/app-utils';

export function useTrackCheckoutPopup(shopDomain: string) {
  const trackCheckoutPopup = () => {
    if (typeof window === 'undefined') return;

    const name = isCartPage() ? 'Cart Page' : 'Drawer Cart';

    const data = {
      name,
    };

    fetch(
      `${process.env.REACT_APP_CUSTOMER_API_HOSTNAME}api/candyrack/checkout/track/cart-properties`,
      {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'x-shop': shopDomain,
        },
        body: JSON.stringify(data),
      },
    ).catch((error) => {
      logError(
        'Error sending tracking call on cart page.',
        REGISTERED_APPS.CANDYCART,
        error,
      );
    });
  };

  return { trackCheckoutPopup };
}
